import React, {
  useEffect,
} from 'react';
import isNil from 'lodash/isNil';
import {
  FormProvider,
  useForm,
} from 'react-hook-form';
import VisitNoteForm, {
  Props as VisitNoteFormProps,
} from 'views/EMR/VisitNoteForm';
import {
  SidePanelComponentProps,
} from 'pages/Dashboard/contexts/sidePanel';
import {
  useGetMasterTemplateByName,
} from 'pages/Dashboard/pages/Encounters/pages/VisitNote/hooks';
import Spinner from 'pages/Dashboard/components/Spinner';
import useUserInfo from 'pages/Dashboard/hooks/useUserInfo';
import {
  isEmptyString,
} from '@populateui/utils';

export default function MasterTemplate({ entity, onClose }: SidePanelComponentProps) {
  const userInfo = useUserInfo();
  const { templateName, userId } = entity ?? {};
  const isNew = isEmptyString(templateName);
  const readonly = userInfo?.user?.userId !== userId && !isNew;
  const form = useForm<VisitNoteFormProps>({ mode: 'all' });
  const { reset } = form;
  const { data, isFetching } = useGetMasterTemplateByName(entity?.templateName);

  useEffect(() => {
    if (!isNil(data)) {
      reset(data);
    }
  }, [templateName, data]);

  return (
    <FormProvider {...form}>
      {isFetching ? (
        <div className="w-full flex h-full items-center justify-center">
          <Spinner size={32} />
        </div>
      ) : (
        <VisitNoteForm
          entity={entity}
          onClose={onClose}
          readonly={readonly}
        />
      )}
    </FormProvider>
  );
}
